import { render, staticRenderFns } from "./twilio-email-form.vue?vue&type=template&id=71d6e733"
import script from "./twilio-email-form.vue?vue&type=script&lang=js"
export * from "./twilio-email-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports